import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Spinner from "../components/Spinner";

export default function BlogList() {
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");

    const filteredBlogs = blogs.filter(blog => {
        const title = blog.title || '';
        const author = blog.author || '';
        const tag = blog.tag || '';
        const type = blog.type || '';
        const searchLower = searchTerm.toLowerCase();
        
        return title.toLowerCase().includes(searchLower) ||
               author.toLowerCase().includes(searchLower) ||
               tag.toLowerCase().includes(searchLower) ||
               type.toLowerCase().includes(searchLower);
    });

    const fetchBlogs = () => {
        setLoading(true);
        fetch(`${process.env.REACT_APP_BASE_URL}/blogs/all`)
            .then(res => res.json())
            .then(data => {
                setBlogs(data);
                setLoading(false);
            })
            .catch(e => {
                console.error(e);
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchBlogs();
    }, []);

    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this blog?")) {
            try {
                const response = await fetch(`${process.env.REACT_APP_BASE_URL}/blogs/${id}`, {
                    method: 'DELETE'
                });
                if (response.ok) {
                    alert("Blog deleted successfully!");
                    fetchBlogs();
                } else {
                    alert("Failed to delete blog.");
                }
            } catch (error) {
                console.error("Error deleting blog:", error);
                alert("Error deleting blog.");
            }
        }
    };

    return (
        <div className="p-6 h-screen overflow-y-auto">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4">
                <h1 className="text-2xl font-bold text-gray-800">Select a Blog to Edit</h1>
                <div className="relative w-full sm:w-80">
                    <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                        <svg aria-hidden="true" className="w-5 h-5 text-gray-500" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd"></path></svg>
                    </div>
                    <input 
                        type="text" 
                        className="bg-white border border-gray-300 text-gray-900 text-sm rounded-xl focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-3 shadow-sm transition-shadow outline-none" 
                        placeholder="Search by title, author, tag..." 
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
            </div>
            {loading ? <Spinner /> : (
                <div className="overflow-x-auto bg-white shadow-md rounded-lg">
                    <table className="min-w-full leading-normal">
                        <thead>
                            <tr>
                                <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Title</th>
                                <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Author</th>
                                <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Type / Style</th>
                                <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Date</th>
                                <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredBlogs.map(blog => (
                                <tr key={blog.id} className="hover:bg-gray-50 transition">
                                    <td className="px-5 py-5 border-b border-gray-200 text-sm font-medium text-gray-800">{blog.title || '(No Title)'}</td>
                                    <td className="px-5 py-5 border-b border-gray-200 text-sm text-gray-600">{blog.author}</td>
                                    <td className="px-5 py-5 border-b border-gray-200 text-sm text-gray-600">{blog.type} / <span className="font-bold text-gray-800">Style {blog.blogtype || 'B'}</span></td>
                                    <td className="px-5 py-5 border-b border-gray-200 text-sm text-gray-600">{blog.date}</td>
                                    <td className="px-5 py-5 border-b border-gray-200 text-sm font-medium">
                                        <div className="flex gap-2">
                                            <Link to={`/edit-blog/${blog.id}`} className="text-white bg-red-600 hover:bg-red-700 px-4 py-2 rounded shadow">Edit</Link>
                                            <button 
                                                onClick={() => handleDelete(blog.id)} 
                                                className="text-white bg-red-600 hover:bg-red-700 px-4 py-2 rounded shadow"
                                            >
                                                Delete
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                            {filteredBlogs.length === 0 && (
                                <tr>
                                    <td colSpan="5" className="px-5 py-5 border-b border-gray-200 bg-white text-sm text-center text-gray-500">
                                        {blogs.length === 0 ? "No blogs found. Create one first!" : "No blogs match your search."}
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}

